'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function IconWikisTiny(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", width: "1em", height: "1em" }, props),
        React__namespace.createElement("path", { d: "M10 1H8c-.27 0-.52.11-.71.29L6 2.59l-1.29-1.3C4.52 1.11 4.27 1 4 1H2C.9 1 0 1.9 0 3v5c0 1.1.9 2 2 2h1.59l1.71 1.71c.01.01.02.01.03.02.09.08.18.15.29.2.12.04.25.07.38.07s.26-.03.38-.08c.11-.05.21-.12.29-.2.01-.01.02-.01.03-.02L8.41 10H10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM4 8H2V3h1.59L5 4.41v4.17l-.29-.29C4.52 8.11 4.27 8 4 8zm6 0H8c-.27 0-.52.11-.71.29l-.29.3V4.41L8.41 3H10v5z" })));
}

module.exports = IconWikisTiny;
